import { Badge } from "../../../components/Badge";
import { CardHR } from "../../../components/layout/Card";
import {
  IconSize,
  MOBILE_SCREEN,
  SPACING,
  SUCCESS_GRADIENT,
  WARNING_GRADIENT,
} from "../../../components/theme";
import {
  ParagraphSmall,
  ParagraphHeader,
} from "../../../components/typography/Paragraph";
import {
  ICON_COMPONENTS,
  getIconBackgroundColor,
} from "../../questionnaire/utils/icons";
import {
  HeaderRow,
  HeaderLeft,
  StyledIconContainer,
  HeaderContent,
} from "./DisputeComponents";
import styled from "@emotion/styled";

const StyledHeaderContainer = styled.div`
  margin-bottom: ${SPACING.LG};
  display: flex;
  gap: ${SPACING.MD};
  ${MOBILE_SCREEN} {
    margin-bottom: ${SPACING.MD};
  }
`;

interface CardHeaderProps {
  isResolved: boolean;
  title: string | null;
  groupIcon: string | null;
}

export const CardHeader: React.FC<CardHeaderProps> = ({
  isResolved,
  title,
  groupIcon,
}) => {
  const sectionTitle = title ?? "General";
  const IconComponent = groupIcon
    ? ICON_COMPONENTS[groupIcon as keyof typeof ICON_COMPONENTS]
    : null;
  const backgroundColor = getIconBackgroundColor(groupIcon ?? "");

  return (
    <>
      <StyledHeaderContainer>
        <HeaderRow>
          <HeaderLeft>
            {groupIcon && IconComponent && (
              <StyledIconContainer backgroundColor={backgroundColor}>
                <IconComponent size={IconSize.XL} isChecked={false} />
              </StyledIconContainer>
            )}
            <HeaderContent>
              <ParagraphSmall>Let&apos;s align on:</ParagraphSmall>
              <ParagraphHeader>{sectionTitle}</ParagraphHeader>
            </HeaderContent>
          </HeaderLeft>
          <Badge
            style={{
              background: isResolved ? SUCCESS_GRADIENT : WARNING_GRADIENT,
            }}
          >
            {isResolved ? "Resolved" : "Issue needs resolving"}
          </Badge>
        </HeaderRow>
      </StyledHeaderContainer>
      <CardHR />
    </>
  );
};
